export const formatColumnType = (type) => {
  switch (type) {
    case 'Int64':
    case 'UInt64':
    case 'Float64':
      return 'Numeric';
    case 'Boolean':
      return 'Boolean';
    case 'DateTime':
    case 'DateTime64':
      return 'Date';
    case 'String':
    case 'EmailAddress':
      return 'Text';
    default:
      return 'Other';
  }
};
